import React, { memo } from 'react';
import { PackVisual } from './PackVisual';
interface PackCardProps {
  title: string;
  description: string;
  packTitle: string;
  themeColor: 'blue' | 'green' | 'pink' | 'purple' | 'teal' | 'navy';
  imageSrc?: string;
  href: string;
  delay: number;
  priority?: boolean;
  ctaLabel: string;
  viewLabel: string;
  buyLabel: string;
}
function PackCardBase({
  title,
  description,
  packTitle,
  themeColor,
  imageSrc,
  href,
  delay,
  priority = false,
  ctaLabel,
  viewLabel,
  buyLabel
}: PackCardProps) {
  const animationClass = priority ? '' : 'mp-anim-fade-up mp-card-cv';
  const styleProp = priority ? undefined : {
    animationDelay: `${delay}s`
  };
  const slug = `${packTitle}-${title}`.replace(/\s+/g, '-');
  return <article className={`mp-card-hover bg-white rounded-[2rem] p-6 flex flex-col shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 h-full w-full max-w-[320px] lg:max-w-[300px] overflow-hidden ${animationClass}`} style={styleProp} aria-labelledby={`pack-${slug}`} data-id="element-1">
      <a href={href} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" aria-label={`${viewLabel} ${title}`} data-id="element-2">
        <PackVisual title={packTitle} themeColor={themeColor} imageSrc={imageSrc} priority={priority} data-id="element-3" />
      </a>

      <div className="flex flex-col flex-grow text-center mt-2" data-id="element-4">
        <h2 id={`pack-${slug}`} className="text-xl font-bold text-gray-900 mb-3" data-id="element-5">
          {title}
        </h2>
        <p className="text-sm text-gray-500 leading-relaxed mb-8 flex-grow" data-id="element-6">
          {description}
        </p>

        <a href={href} target="_blank" rel="noopener noreferrer" className="w-full min-h-[56px] bg-[#0F0F0F] hover:bg-black text-white font-bold px-6 rounded-full flex items-center justify-center gap-2 transition-transform active:scale-95 group mt-auto whitespace-nowrap text-base leading-none" aria-label={`${buyLabel} ${title}`} data-id="element-7">
          <span data-id="element-8">{ctaLabel}</span>
          <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 group-hover:translate-x-1 transition-transform" data-id="element-9">
            <path d="M5 12h14" data-id="element-10" />
            <path d="m12 5 7 7-7 7" data-id="element-11" />
          </svg>
        </a>
      </div>
    </article>;
}
export const PackCard = memo(PackCardBase);